import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Wähle deinen Startplan <br/> Wir übernehmen alles, <underline>DU</underline> lehnst dich zurück 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Zahlen aus Umsatz',
    [BillingMode.Stripe]: '(0)[Jetzt zahlen];(1-inf)[Jetzt zahlen (spare bis zu {{discount}})]',
  },
};
